var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"course"},[_c('img',{attrs:{"src":require('@/assets/bz2.jpg'),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }